import { useCoreInit } from '@vivli/core/infrastructure/hook';
import { IContextWrapper } from '@vivli/shared/infrastructure/interface';
import { useEffect, useState } from 'react';
import { PlatformMsalInitWrapper } from './platform-msal-init.wrapper';
import { ModalProvider } from './modal-provider.wrapper';
import { CoreContext } from '@vivli/core/infrastructure/context';

export const PlatformCoreInitWrapper = ({ children }: IContextWrapper) => {
    const [isReady, setIsReady] = useState(false);

    const coreHooks = useCoreInit();

    useEffect(() => {
        if (coreHooks.translationsLoaded && coreHooks.config) {
            setIsReady(true);
        }
    }, [coreHooks.translationsLoaded, coreHooks.config]);

    if (!isReady) {
        return null;
    }

    return (
        <CoreContext.Provider value={coreHooks}>
            <ModalProvider>
                <PlatformMsalInitWrapper>{children}</PlatformMsalInitWrapper>
            </ModalProvider>
        </CoreContext.Provider>
    );
};
